module.exports = __webpack_public_path__ + "static/media/expected-position-icon.4edd4396.png";